import { useContent } from "../content/ContentContext";

const variants = {
  dark: "bg-ink text-white hover:bg-plum",
  light: "border border-ink bg-transparent text-ink hover:border-plum hover:text-plum",
  cream: "bg-cream text-plum hover:bg-white",
};

export default function EmailMeButton({
  label = "Email me",
  arrow = "→",
  variant = "dark",
  testid = "email-me-button",
  className = "",
}) {
  const { content } = useContent();
  return (
    <a
      href={`mailto:${content.site.email}?subject=${encodeURIComponent("Project enquiry — Savvy Stephanie")}`}
      data-testid={testid}
      className={`inline-flex items-center justify-center gap-2 px-5 py-3 font-sans text-xs font-bold uppercase tracking-[0.18em] transition-all duration-200 hover:-translate-y-0.5 ${variants[variant]} ${className}`}
    >
      {label} <span aria-hidden="true">{arrow}</span>
    </a>
  );
}
